import Vue from 'vue'
import VueRouter from 'vue-router'

import { getToken } from '@/utils/index'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'

NProgress.configure({ showSpinner: false })

const Login = () => import('@/pages/login')
const Layout = () => import('@/layout')

import Industry from '@/router/industry'
import Classify from '@/router/classify'
import Notice from '@/router/notice'
import Featured from '@/router/featured'

import User from '@/router/user'
import Company from '@/router/company'
import Park from '@/router/park'
import Meeting from '@/router/meeting'
import Electronic from '@/router/electronic'
import CompanyServe from '@/router/serve'
import Basic from '@/router/basic'
import Authority from '@/router/authority'
import Cloud from '@/router/cloud'
import Complaint from '@/router/complaint'

Vue.use(VueRouter)

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

const children = [
  ...Industry,
  ...User,
  ...Company,
  ...Park,
  ...Meeting,
  ...Electronic,
  ...CompanyServe,
  ...Basic,
  ...Authority,
  ...Classify,
  ...Notice,
  ...Featured,
  ...Cloud,
  ...Complaint
]

const routes = [
  {
    path: '',
    redirect: '/layout'
  },
  {
    path: '/layout',
    component: Layout,
    children
  },
  {
    path: '/login',
    component: Login
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  const token = getToken()
  if (token) {
    if (to.path === '/login') {
      next()
      NProgress.done()
    } else { next() }
  } else {
    if (to.path === '/login') {
      next()
    } else {
      next({ path: '/login' })
      NProgress.done()
    }
  }
})

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
  NProgress.done()
})

export default router
